const ACHIEVEMENT_SUCCESS = '@achievement/achievementSuccess';

export default ACHIEVEMENT_SUCCESS;
